import { routes } from 'constants/config';
import request from 'utils/request_ajax';

const fileInformationRequest = async uploadId => {
  const { id, name, size, url } = await request.get(
    routes.FILE_UPLOAD.BSS.FILE_INFORMATION(uploadId),
  );
  return { id, name, size, url };
};

const bytesToSize = bytes => {
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (bytes === 0) return '';
  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
  if (i === 0) return `${bytes} ${sizes[i]})`;
  return `${(bytes / 1024 ** i).toFixed(1)} ${sizes[i]}`;
};

export { bytesToSize, fileInformationRequest };
